export const getters = {
  productsByGroup: state => groupId => {
    return state.products.filter(p => p.group.id === groupId)
  },
}
